<!-- Mobile backdrop -->
@if (mobileOpen()) {
  <div class="fixed inset-0 bg-black/40 z-[35] md:hidden" (click)="closeMobile()"></div>
}

<!-- Mobile hamburger -->
<button
  (click)="toggleMobile()"
  class="fixed top-4 z-50 md:hidden p-2 rounded-lg bg-white border border-stone-200 shadow-sm transition-[left] duration-300"
  [style.left]="mobileOpen() ? 'calc(16rem + 0.75rem)' : '0.75rem'"
  [attr.aria-expanded]="mobileOpen()"
  aria-label="Menu"
  title="Menu"
>
  <svg class="w-5 h-5 text-stone-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
    @if (mobileOpen()) {
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    } @else {
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    }
  </svg>
</button>

<aside
  class="fixed left-0 top-0 bottom-0 min-h-dvh h-screen transition-all duration-300 z-40 flex flex-col"
  style="background: linear-gradient(160deg, #0a4342, #0e5a58);"
  [class.w-64]="isOpen()"
  [class.w-20]="!isOpen()"
  [class.sidebar-mobile-open]="mobileOpen()"
>
  <!-- Header -->
  <div style="padding: 12px; height: 4.5rem; border-bottom: 1px solid #374151;" class="flex items-center">
    @if (isOpen()) {
      <div class="w-full flex items-center justify-center">
        <img src="assets/imgs/sportiq-logo-v2.png" alt="SportIQ" style="height: 3rem;" class="object-contain" />
      </div>
    }
  </div>

  <!-- Toggle Button -->
  <button
    (click)="toggleSidebar()"
    class="absolute top-20 -right-5 p-2 rounded-lg transition-all z-50 hidden md:block"
    style="border: 3px solid #fafbf6; background-color: #111827; color: #fafbf6;"
    title="Toggle sidebar"
  >
    <svg class="w-4 h-4 transition-transform" stroke="#fafbf6"
      [style.transform]="!isOpen() ? 'scaleX(-1)' : 'scaleX(1)'"
      fill="none" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <!-- Expanded nav -->
  @if (isOpen()) {
    <nav class="flex-1 px-3 py-6 space-y-1 overflow-y-auto">
      <p class="px-4 mb-2 text-xs font-semibold uppercase tracking-widest" style="color:#DFFBED">{{ platformLabel() }}</p>
      @for (item of navItems(); track item.route; let i = $index) {
        @if (item.section && item.section !== previousSection(navItems(), i)) {
          <p class="px-4 mt-5 mb-1 text-[10px] font-semibold uppercase tracking-widest opacity-70" style="color:#DFFBED">{{ item.section }}</p>
        }
        <button
          (click)="navigate(item.route)"
          class="nav-item w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200"
          [class.nav-active]="isActive(item.route)"
          [title]="item.label"
        >
          <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg">
            <span class="material-icons text-sm" style="color:#DFFBED">{{ item.icon }}</span>
          </span>
          <span class="text-sm font-medium truncate" style="color:#DFFBED">{{ item.label }}</span>
        </button>
      }
    </nav>

    <div style="border-top: 1px solid #374151;" class="px-3 py-4">
      <div class="px-4 py-2 text-center">
        <p class="text-xs" style="color:#DFFBED">SportIQ Main v1.0</p>
      </div>
    </div>
  }

  <!-- Collapsed: icons only -->
  @if (!isOpen()) {
    <nav class="flex-1 px-2 py-6 space-y-3 overflow-y-auto">
      @for (item of navItems(); track item.route) {
        <button
          (click)="navigate(item.route)"
          class="nav-item w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200"
          [class.nav-active]="isActive(item.route)"
          [title]="item.label"
        >
          <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg">
            <span class="material-icons text-sm" style="color:#DFFBED">{{ item.icon }}</span>
          </span>
        </button>
      }
    </nav>
  }
</aside>

<!-- Spacer (desktop) -->
<div
  class="transition-all duration-300 hidden md:block flex-shrink-0"
  [class.md:w-64]="isOpen()"
  [class.md:w-20]="!isOpen()"
  style="background: linear-gradient(160deg, #0a4342, #0e5a58);"
></div>
